export const InsuranceProvider = [
  'Blue Cross Blue Shield (BCBS)',
  'United Health Care (UHC)',
  'Cigna / Evernorth',
  'TriCare',
  'Anthem',
  'Other',
  'Insurance Not Listed / Not Accepted',
];

export const DiagnoticianType = [
  { name: 'Type 1', value: 'type1' },
  { name: 'Type 2', value: 'type2' },
  { name: 'Type 3', value: 'type3' },
];

export const hearAboutUs = [
  'Primary Care Provider (PCP)/ Physician',
  'Therapist/ Counselor',
  'Hospital/ ER',
  'Insurance Payor',
  'School/ IEP team',
  'Google/ Internet Search',
  'Social Media (Facebook/ Instagram/ Other)',
  'Online Video (YouTube / Streaming Ads)',
  'AI Tools (ChatGPT/ Perplexity/ Gemini/ Other)',
  'Word of Mouth (Friend/ Family/ Another Parent)',
  'Other',
];

export const YES = 'yes';
export const NO = 'no';

/**
 * MM-1136: primary provider id saved for "No assigned provider". patient-mgmt treats it the same as no
 * provider and syncs the patient to DrChrono with its default doctor; screens reading the patient's
 * providerId treat it as not assigned.
 */
export const UNASSIGNED_PROVIDER_ID = 'default';

/**
 * MM-1136: the patient's primary provider id as self-scheduling reads it - null when no provider is
 * assigned, including "No assigned provider" (UNASSIGNED_PROVIDER_ID).
 */
export const toAssignedProviderId = (providerId?: string | number | null): string | null => {
  const value = providerId === null || providerId === undefined ? '' : String(providerId).trim();
  return value && value.toLowerCase() !== UNASSIGNED_PROVIDER_ID ? value : null;
};

export const CustodyType = [
  { label: 'Yes', key: 'yes' },
  { label: 'No', key: 'no' },
];

export const StatusYesNo = [
  { name: 'Yes', value: 'Yes' },
  { name: 'No', value: 'No' },
];

export const SchoolingType = [
  { key: '1', value: 'yes' },
  { key: '0', value: 'no' },
];
export const GaurdianRelation = [
  { name: 'Mother', value: 'Mother' },
  { name: 'Father', value: 'Father' },
  { name: 'Legal Guardian', value: 'Guardian' },
];

export enum permissions {
  EDIT_PROFILE = 'EDIT_PROFILE',
  GLOBAL_EDIT_PROFILE = 'GLOBAL_EDIT_PROFILE',
  VIEW_PROFILE = 'VIEW_PROFILE',
  TAKE_MCAT = 'TAKE_MCAT',
  UPDATE_MCAT_SCORE = 'UPDATE_MCAT_SCORE',
  DOWNLOAD_MCAT = 'DOWNLOAD_MCAT',
  TAKE_MFSH = 'TAKE_MFSH',
  DOWNLOAD_MFSH = 'DOWNLOAD_MFSH',
  TAKE_WELLBEING = 'TAKE_WELLBEING',
  DOWNLOAD_WELLBEING = 'DOWNLOAD_WELLBEING',
  VIEW_WELLBING_RESULT = 'VIEW_WELLBING_RESULT',
  REQUEST_APPOINTMENT = 'REQUEST_APPOINTMENT',
  CREATE_APPOINTMENT = 'CREATE_APPOINTMENT',
  VIEW_APPOINTMENT = 'VIEW_APPOINTMENT',
  VIEW_INSURANCE = 'VIEW_INSURANCE',
  SAVE_APPOINTMENT_DATA = 'SAVE_APPOINTMENT_DATA',
  VIEW_APPOINTMENT_DATA = 'VIEW_APPOINTMENT_DATA',
  SAVE_EHR_DETAILS = 'SAVE_EHR_DETAILS',
  VIEW_EHR_DETAILS = 'VIEW_EHR_DETAILS',
  VIEW_DOCUMENTS = 'VIEW_DOCUMENTS',
  REVIEW_DOCUMENTS = 'REVIEW_DOCUMENTS',
  SEND_REMINDERS = 'SEND_REMINDERS',
  VIEW_PATIENTS = 'VIEW_PATIENTS',
  CREATE_PATIENT = 'CREATE_PATIENT',
  UPLOAD_DOCUMENTS= 'UPLOAD_DOCUMENTS',
  /** MM-1106: permanent delete of a patient (Admin / Tech VMA only) */
  HARD_DELETE_PATIENT = 'HARD_DELETE_PATIENT',
}

export const Regions = [
  { name: 'Chicagoland', value: 'Chicagoland' },
  { name: 'STL Metro East', value: 'STL Metro East' },
  { name: 'St. Louis Metro', value: 'St. Louis Metro' },
  { name: 'Northern IL', value: 'Northern IL' },
  { name: 'Central IL', value: 'Central IL' },
  { name: 'Southern IL', value: 'Southern IL' },
];

export const OrganizationTypes = [
  { name: 'Counselor', value: 'Counselor' },
  { name: 'PCP Pediatrics', value: 'PCP Pediatrics' },
  { name: 'PCP Family Med', value: 'PCP Family Med' },
  { name: 'PCP Unspecified', value: 'PCP Unspecified' },
  { name: 'Neuropsychologist', value: 'Neuropsychologist' },
  { name: 'Autism Services', value: 'Autism Services' },
  { name: 'Pediatric Therapist (Speech, OT, PT)', value: 'Pediatric Therapist (Speech, OT, PT)' },
  { name: 'Other', value: 'Other' },
];

export const OrganizationStatus = [
  { name: 'Approved', value: 'Approved' },
  { name: 'In-Pipeline', value: 'In-Pipeline' },
  { name: 'Rejected', value: 'Rejected' },
];

export const USStates = [
  { name: 'Alabama', value: 'Alabama' },
  { name: 'Alaska', value: 'Alaska' },
  { name: 'Arizona', value: 'Arizona' },
  { name: 'Arkansas', value: 'Arkansas' },
  { name: 'California', value: 'California' },
  { name: 'Colorado', value: 'Colorado' },
  { name: 'Connecticut', value: 'Connecticut' },
  { name: 'Delaware', value: 'Delaware' },
  { name: 'Florida', value: 'Florida' },
  { name: 'Georgia', value: 'Georgia' },
  { name: 'Hawaii', value: 'Hawaii' },
  { name: 'Idaho', value: 'Idaho' },
  { name: 'Illinois', value: 'Illinois' },
  { name: 'Indiana', value: 'Indiana' },
  { name: 'Iowa', value: 'Iowa' },
  { name: 'Kansas', value: 'Kansas' },
  { name: 'Kentucky', value: 'Kentucky' },
  { name: 'Louisiana', value: 'Louisiana' },
  { name: 'Maine', value: 'Maine' },
  { name: 'Maryland', value: 'Maryland' },
  { name: 'Massachusetts', value: 'Massachusetts' },
  { name: 'Michigan', value: 'Michigan' },
  { name: 'Minnesota', value: 'Minnesota' },
  { name: 'Mississippi', value: 'Mississippi' },
  { name: 'Missouri', value: 'Missouri' },
  { name: 'Montana', value: 'Montana' },
  { name: 'Nebraska', value: 'Nebraska' },
  { name: 'Nevada', value: 'Nevada' },
  { name: 'New Hampshire', value: 'New Hampshire' },
  { name: 'New Jersey', value: 'New Jersey' },
  { name: 'New Mexico', value: 'New Mexico' },
  { name: 'New York', value: 'New York' },
  { name: 'North Carolina', value: 'North Carolina' },
  { name: 'North Dakota', value: 'North Dakota' },
  { name: 'Ohio', value: 'Ohio' },
  { name: 'Oklahoma', value: 'Oklahoma' },
  { name: 'Oregon', value: 'Oregon' },
  { name: 'Pennsylvania', value: 'Pennsylvania' },
  { name: 'Rhode Island', value: 'Rhode Island' },
  { name: 'South Carolina', value: 'South Carolina' },
  { name: 'South Dakota', value: 'South Dakota' },
  { name: 'Tennessee', value: 'Tennessee' },
  { name: 'Texas', value: 'Texas' },
  { name: 'Utah', value: 'Utah' },
  { name: 'Vermont', value: 'Vermont' },
  { name: 'Virginia', value: 'Virginia' },
  { name: 'Washington', value: 'Washington' },
  { name: 'West Virginia', value: 'West Virginia' },
  { name: 'Wisconsin', value: 'Wisconsin' },
  { name: 'Wyoming', value: 'Wyoming' },
];

export const CarePlans = [
  { key: 0, name: 'Select Care Plan', value: 'select_treatment_plan', disabled: true },
  { key: 1, name: 'Psychiatry', value: 'Psychiatry', disabled: false },
  { key: 2, name: 'Therapy', value: 'Therapy', disabled: false },
  { key: 3, name: 'Psychiatry & Therapy', value: 'Psychiatry & Therapy', disabled: false },
];

export const InsuranceStatus = [
  { key: 1, name: 'Insurance Card Active', value: 'Insurance Card Active' },
  { key: 2, name: 'Insurance Card Inactive', value: 'Insurance Card Inactive' },
  { key: 3, name: 'Out of Pocket', value: 'Out of Pocket' },
];

export const Pronouns = [
  { key: 0, name: 'Choose Pronouns', value: 'choose_preferred_gender', disabled: true },
  { key: 1, name: 'He/Him', value: 'He/Him' },
  { key: 2, name: 'She/Her', value: 'She/Her' },
  { key: 3, name: 'They/Them', value: 'They/Them' },
  { key: 4, name: 'Other', value: 'other' },
];

export const AppointmentStatus = [
  'Scheduled',
  'Confirmed',
  'Complete',
  'Cancelled',
  'Late Cancel',
  'Bumped',
  'No-show',
];

export const UserStatus = ['UNVERIFIED', 'REGISTERED', 'verified', 'ACTIVE'];

export const BiologicalGender = [
  { key: '1', value: 'Male' },
  { key: '2', value: 'Female' },
];

export const Migrated = [
  { name: 'Migrated & Active', value: 'MG-A' },
  { name: 'Migrated & Registered', value: 'MG-R' },
  { name: 'Self Registered', value: 'Self' },
];
export const CreditCardStatus = [
  { key: 1, name: 'Active', value: 'Active' },
  { key: 2, name: 'Inactive', value: 'Inactive' },
];

export const BillingStatus = [
  { key: 1, name: 'Profit Recovery', value: 'Profit Recovery' },
  { key: 2, name: 'Collections', value: 'Collections' },
  { key: 3, name: 'Current', value: 'Current' },
];

export const Locations = [
  {
    id: 1,
    filterValue: 'Maryville',
    location: '24B Professional Park Dr, Maryville, IL',
    state: 'IL',
    // eslint-disable-next-line max-len
    instruction:
      'Conveniently accessible from I-55 and I-270. Located at the intersection of IL-159 & IL-162 inside Maryville Professional Park.',
  },
  {
    id: 2,
    filterValue: 'Naperville',
    location: '1315 Macom Dr, Suite 207, Naperville, IL',
    state: 'IL',
    // eslint-disable-next-line max-len
    instruction:
      'Conveniently accessible from Route 59 and 83rd Street. We are in Suite 207, co-located with English Meadows Counseling Services',
  },
  {
    id: 3,
    filterValue: 'Hinsdale',
    location: '19 E First Street, Hinsdale, IL',
    state: 'IL',
    // eslint-disable-next-line max-len
    instruction:
      'Conveniently accessible from I-294. Located on 1st Street between S Washington Street and S Garfield Street. We are on the second floor in Suite D. Plenty of street parking and a free parking lot on Garfield Street; take the stairs to First Street.',
  },
  {
    id: 4,
    filterValue: 'Richmond Heights',
    location: '1034 S Brentwood Blvd, Suite 555, Richmond Heights, MO',
    state: 'MO',
    // eslint-disable-next-line max-len
    instruction:
      'Located just off I-170 across from the Galleria Mall. Park in the front lot, enter through the main lobby, take the elevator to the 5th floor, and follow signs to Gateway Wellness Associates, Suite 555.',
  },
  {
    id: 5,
    filterValue: 'Palatine',
    location: '1 E Northwest Hwy, Suite 212, Palatine, IL',
    state: 'IL',
    // eslint-disable-next-line max-len
    instruction:
      'Conveniently located along Northwest Highway (US-14) in downtown Palatine, just steps from the Palatine Metro Station.',
  },
];

export const Roles = [
  {
    id: 1,
    role: 'VMA',
  },
  {
    id: 2,
    role: 'Admin',
  },
  {
    id: 3,
    role: 'VMA Manager',
  },
  {
    id: 4,
    role: 'Billing Manager',
  },
  {
    id: 5,
    role: 'Clinical Manager',
  },
  {
    id: 6,
    role: 'Clinical VMA',
  },

  {
    id: 7,
    role: 'Billing VMA',
  },
  {
    id: 8,
    role: 'Global Manager',
  },
  {
    id: 9,
    role: 'Provider',
  },
  {
    id: 10,
    role: 'Tech VMA',
  },
  {
    id: 11,
    role: 'Other VMA',
  },
];

export const Positions = [
  {
    id: 1,
    position: 'Medical Assistant ',
  },
  {
    id: 2,
    position: 'Medical Assistant Supervisor',
  },
  {
    id: 3,
    position: 'Clinical Provider',
  },
  {
    id: 4,
    position: 'Clinical Provider Supervisor',
  },
  {
    id: 5,
    position: 'Manager',
  },
  {
    id: 7,
    position: 'Director',
  },
  {
    id: 8,
    position: 'Medical Director',
  },
  {
    id: 9,
    position: 'Chief Operating Officer (COO)',
  },
  {
    id: 10,
    position: 'Chief Financial Officer (CFO)',
  },
  {
    id: 11,
    position: 'Chief Executive Officer (CEO)',
  },
];

export const roles_key: any = [
  'clinical_manager',
  'clinical_vma',
  'vma',
  'billing_vma',
  'vma_manager',
  'billing_manager',
  'global_manager',
  'provider',
  'miscellaneous',
  'tech_vma',
  'admin',
];

export const Days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const JobStatus = [
  'Approved',
  'Rejected',
  'Transfer Failed',
  'Transfer Successful',
  'Update Failed',
  'Update Successful',
];

export const AppStatus = [
  '',
  'Confirmed',
  'Complete',
  'Cancelled',
  'Finished no followup',
  'No Show',
  'LC',
  'LC and DC',
  'NS',
  'NS and DC',
];

export const Providers = [
  'Elaine Fitzgerald',
  'Gina Wolff',
  'Katherine Napier',
  'Rahul Bansal',
  'Rebekah Feeney',
  'Meagan Fedele-Toleman',
  'Mya Shaikh',
];
